module.exports = __webpack_public_path__ + "img/home1.38115dd6.svg";